import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useI18n } from "../../i18n/LanguageContext";
import { Badge } from "../../components/ui/badge";
import { toast } from "sonner";

export default function SuperAdminExams() {
  const { t } = useI18n();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.saAttempts().then(setRows).catch((e) => { toast.error(e.message); setRows([]); });
  }, []);

  return (
    <div className="space-y-6" data-testid="sa-exams-page">
      <header>
        <div className="text-xs font-bold uppercase tracking-widest text-[#F72585]">{t("superadmin.title")}</div>
        <h1 className="text-3xl md:text-4xl font-black tracking-tight">{t("superadmin.exams")}</h1>
      </header>
      <div className="rounded-2xl border border-black/5 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-black/5">
            <tr>
              <Th>attempt_id</Th><Th>user_id</Th><Th>course_id</Th><Th>status</Th>
              <Th>score</Th><Th>passed</Th><Th>started</Th>
            </tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={7} className="p-6 text-center text-black/50">{t("superadmin.loading")}</td></tr>}
            {rows?.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-black/50">{t("superadmin.empty")}</td></tr>}
            {rows?.map((a) => (
              <tr key={a.attempt_id} className="border-t border-black/5" data-testid={`sa-attempt-${a.attempt_id}`}>
                <Td className="font-mono text-xs">{a.attempt_id}</Td>
                <Td className="font-mono text-xs">{a.user_id}</Td>
                <Td className="font-mono text-xs">{a.course_id}</Td>
                <Td>
                  <Badge className={`text-[10px] ${
                    a.status === "submitted" ? "bg-[#4CC9F0]/20 text-[#0A5566]" : "bg-[#FFB703]/20 text-[#7A4B00]"
                  }`}>{a.status}</Badge>
                </Td>
                <Td className="font-black text-[#4361EE]">{a.score_percent != null ? `${a.score_percent}%` : "-"}</Td>
                <Td>
                  {a.passed === true && <Badge className="bg-[#4CC9F0]/20 text-[#0A5566] text-[10px]">passed</Badge>}
                  {a.passed === false && <Badge className="bg-[#D90429]/15 text-[#D90429] text-[10px]">failed</Badge>}
                </Td>
                <Td className="text-xs text-black/60">{a.started_at?.slice(0, 16).replace("T", " ")}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Th({ children }) { return <th className="text-start px-3 py-2.5 text-[11px] font-black uppercase tracking-wider text-black/60">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-3 py-2.5 ${className}`}>{children}</td>; }
